import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class BillPaymentService extends CrudRequest {
  static baseUrl() {
    return 'cashoutinvoice/controle-estorno-pagamento';
  }

  static done(id) {
    return this.basePatch(`${id}/concluir`);
  }

  static analysis(id) {
    return this.basePatch(`${id}/em-analise`);
  }

  static recuse(id) {
    return this.basePatch(`${id}/reprovar`);
  }

  static basePatch(path) {
    return httpService.patch(
      `${this.baseUrl()}/${path}`,
    );
  }
}
